import { render } from "./Manufacturer.vue?vue&type=template&id=3fc37724&scoped=true"
import script from "./Manufacturer.vue?vue&type=script&lang=js"
export * from "./Manufacturer.vue?vue&type=script&lang=js"

import "./Manufacturer.vue?vue&type=style&index=0&id=3fc37724&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc37724"]])

export default __exports__